export const PENDING_INTAKE_UNAVAILABLE_CODE = 'PENDING_INTAKE_UNAVAILABLE';

export function isPendingIntakeUnavailableError(error) {
  return error?.code === PENDING_INTAKE_UNAVAILABLE_CODE;
}

export async function isPendingIntakeUnavailableHttpResponse(response) {
  if (response?.status !== 503) return false;
  try {
    const body = await response.clone().json();
    return body?.code === PENDING_INTAKE_UNAVAILABLE_CODE;
  } catch {
    return false;
  }
}
